







































































































































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {CommentQue, FAQ, ReviewRate} from '@/store/RateReviewFaq/types';
import BIcon from 'buefy/src/components/icon/Icon.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import BLoading from 'buefy/src/components/loading/Loading.vue';
import BField from 'buefy/src/components/field/Field.vue';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';
import * as firebase from 'firebase/app';
import DocumentReference = firebase.firestore.DocumentReference;
import luxon from '@/plugins/luxon';
import {Lookup, LookupIcon} from '@/store/types';
import {OptionType} from '@/components/common/types';

// TODO: fix
/* tslint:disable:no-empty */
/* tslint:disable:no-console */

const userPath = 'userState';
const userNamespace = namespace(userPath);
const ratePath = 'rateState';
const rateNamespace = namespace(ratePath);
const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);
@Component({
    components: {BIcon, BButton, BInput, BField, BLoading},
})
export default class ProfileUpdateModal extends Vue {
    @Prop() public readonly self!: MAFUser | undefined;
    @userNamespace.Action('updateUser') public updateUser!: any;
    @userNamespace.Action('deleteUser') public deleteUser!: any;
    @userNamespace.State('diagnosis') public diagnosis!: Lookup;
    @userNamespace.Getter('getUserType')  public userTypes: string[] | undefined;
    @userNamespace.Getter('getDiagnosis')  public getDiagnosis!: string[] | undefined;
    @userNamespace.Getter('getFunStuff') public getFunStuff!: LookupIcon[];
    @userNamespace.Getter('getGroupFunStuff') public getGroupFunStuff!: LookupIcon[];

    public severityOptions: OptionType[];
    public genderOptions: OptionType[];
    public providerOptions: OptionType[];
    public diagnosisMessage: string = '';
    constructor() {
        super();
        this.severityOptions = [
            {value: 1, display: 'Low'},
            {value: 2, display: 'Medium Low'},
            {value: 3, display: 'Medium'},
            {value: 4, display: 'Medium High'},
            {value: 5, display: 'High'},
        ];
        this.genderOptions = [
            {value: 'male', display: 'Male'},
            {value: 'female', display: 'Female'},
            {value: 'other', display: 'Prefer Not To Say'},
        ];
        this.providerOptions = [
            {value: 'AT&T', display: 'AT&T'},
            {value: 'Verizon', display: 'Verizon'},
            {value: 'Sprint', display: 'Sprint'},
            {value: 'TMobile', display: 'T Mobile'},
        ];
    }

    public parseDate(date: string) {
        return DateTime.fromISO(date).toJSDate();
    }
    public formatDate(date: Date) {
        return DateTime.fromJSDate(date).toFormat('DDD');
    }
    public async save() {
        try {
            await this.updateUser(this.self);
        } catch (e) {
            console.log(e);
        }
    }

    public saveSelf() {

    }

    public async onDeactivateAccount() {
        const conf = confirm('Are you sure you\'d like to delete your account? Doing so will erase your user content for all of eternity! You will not be able to create another account with this email. Users you\'ve been messaging will also keep a copy of your messages for security purposes.');
        if (conf) {
            this.deleteUser(this.self);
            this.$router.push('/');
        }
    }

    @Emit('close')
    public close() {
    }
    @Emit('avatar')
    public avatar() {

    }
    @Emit('upload')
    public upload() {

    }
}
